import { Link } from "react-router-dom"

function PrivacyPolicy() {
    return (
        <>
            <div className="privacy px-3 pt-3">
                <h2 className="fw-semibold Privacy_head">Privacy Policy for CareerSahi Platform</h2>
                <p><span className="fw-bold">Effective Date:</span> 01/01/2025</p>
                <section>
                    <h3 className="fw-semibold">Introduction</h3 >
                    <p>Welcome to CareerSahi ("we," "our," or "us"). Your privacy is important to us, and we are committed to protecting the information you share with us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use the CareerSahi platform ("Platform"). Please read this policy carefully to understand our practices regarding your information.</p>
                </section>
                <section>
                    <h3 className="fw-semibold">1. Information We Collect</h3>
                    <ul>
                        <li><strong className="fw-bold">Personal Information:</strong> Name, Email address, Phone number, Address, Payment information (for processing transactions)</li>
                        <li><strong className="fw-bold">Non-Personal Information:</strong> Device information (e.g., IP address, browser type, operating system), Usage data (e.g., pages viewed, time spent on the Platform), Cookies and similar technologies</li>
                        <li><strong className="fw-bold">Information from Third Parties:</strong> Data from payment processors like Razorpay to facilitate transactions</li>
                    </ul>
                </section>
                <section>
                    <h3 className="fw-semibold">2. How We Use Your Information</h3>
                    <p>We use the information we collect for the following purposes:</p>
                    <ul>
                        <li>To provide and maintain our services</li>
                        <li>To process payments and complete transactions</li>
                        <li>To communicate with you about updates, offers, and services</li>
                        <li>To improve the functionality and user experience of our Platform</li>
                        <li>To comply with legal obligations</li>
                    </ul>
                </section>
                <section>
                    <h3 className="fw-semibold">3. Sharing Your Information</h3>
                    <p>We do not sell or rent your personal information to third parties. However, we may share your information in the following circumstances:</p>
                    <ul>
                        <li><strong className="fw-bold">With Payment Processors:</strong> To facilitate transactions (e.g., Razorpay).</li>
                        <li><strong className="fw-bold">With Service Providers:</strong> To support our operations (e.g., hosting, analytics).</li>
                        <li><strong className="fw-bold">For Legal Purposes:</strong> To comply with legal obligations or respond to lawful requests.</li>
                    </ul>
                </section>
                <section>
                    <h3 className="fw-semibold">4. Data Retention</h3>
                    <p>We retain your personal information only as long as necessary to fulfill the purposes outlined in this policy, comply with legal obligations, resolve disputes, and enforce our agreements.</p>
                </section>
                <section>
                    <h3 className="fw-semibold">5. Security of Your Information</h3>
                    <p>We implement reasonable technical and organizational measures to protect your information from unauthorized access, loss, or misuse. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.</p>
                </section>
                <section>
                    <h3 className="fw-semibold">6. Your Rights</h3>
                    <p>Depending on your jurisdiction, you may have the following rights regarding your personal information:</p>
                    <ul>
                        <li>Access your data</li>
                        <li>Correct inaccuracies</li>
                        <li>Request deletion of your data</li>
                        <li>Object to processing</li>
                        <li>Withdraw consent</li>
                    </ul>
                    <p>To exercise these rights, contact us at <strong>
                        <Link to="mailto:info@careersahi.com" className="text-decoration-none fw-semibold pointer text-black">
                            info@careersahi.com
                        </Link></strong>.</p>
                </section>
                <section>
                    <h3 className="fw-semibold">7. Third-Party Links</h3>
                    <p>Our Platform may contain links to third-party websites or services. We are not responsible for the privacy practices of these third parties. We encourage you to review their privacy policies.</p>
                </section>
                <section>
                    <h3 className="fw-semibold">8. Updates to This Privacy Policy</h3>
                    <p>We may update this Privacy Policy from time to time. Any changes will be effective when we post the revised policy on our Platform. Your continued use of the Platform after such changes signifies your acceptance.</p>
                </section>
                <section>
                    <h3 className="fw-semibold">9. Contact Us</h3>
                    <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
                    <address>
                        <span className="fw-bold">CareerSahi</span><br />
                        Email: <span className="fw-bold">  <Link to="mailto:info@careersahi.com" className="text-decoration-none fw-semibold pointer text-black">
                            info@careersahi.com
                        </Link></span><br />
                        Phone: <span className="fw-bold">+91 82382 35437</span>
                    </address>
                </section>
                <p>Thank you for trusting CareerSahi with your information.</p>
            </div>

        </>
    )
}
export default PrivacyPolicy